<template>
  <div
    style="background-color: #dadada"
  >
    <v-tabs
      v-if="$route.name === 'mDashboard'"
      v-model="tab"
      centered
      grow
    >
      <v-tab>
        {{$t('action')}}
      </v-tab>
      <v-tab>
        {{$t('lists')}}
      </v-tab>
      <v-tab>
        {{$t('reports')}}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="tab"
      style="height: calc(100vh - 106px);background-color: #dadada"
      class="pt-2"
    >
      <v-tab-item>
        <v-row class="mx-0">
          <v-alert
            v-if="syncDataErrorAlert"
            border="left"
            type="warning"
          >
            {{ syncDataErrorText }}
          </v-alert>
          <v-col
            cols="4"
            class="px-1 pb-0"
          >
            <v-sheet
              class="pa-2"
              @click="syncData"
              style="border-radius: 15px"
              align="center"
            >
              <v-icon
                color="amber"
                style="font-size: 40px"
              >
                mdi-database-sync-outline
              </v-icon>
              <v-card-text
                style="font-size: 14px;color: #673ab7"
                class="pa-0 mt-2 text-center black--text"
                v-html="$t('syncData')"
              />
            </v-sheet>
          </v-col>
          <mDashboardButtons
            type="action"
            :disable-prop="syncDataErrorAlert"
          />
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <v-row class="mx-0">
          <mDashboardButtons
            type="list"
            :disable-prop="syncDataErrorAlert"
          />
        </v-row>
      </v-tab-item>
      <v-tab-item>
        <m-weekly-sell ref="weeklyRef" />
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="syncDataDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="yellow"
        dark
      >
        <v-card-text>
          {{ $t('syncing') }}...{{ $t(syncDataType) }}
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import General from '@/Mixins/general'
  import mDashboardButtons from '@/views/dashboard/pages/widgets/mDashboardButtons.vue'
  import mWeeklySell from '@/views/dashboard/pages/widgets/mWeeklySell.vue'
  // prefixes of implementation that we want to test
  export default {
    name: 'MDashboard',
    components: {
      mWeeklySell,
      mDashboardButtons,
    },
    mixins: [General],
    data: () => ({
      tab: 0,
      carousel: 1,
      syncDataDialog: false,
      syncDataType: '',
      syncDataErrorText: '',
      syncDataErrorAlert: false,
    }),
    computed: {
    },
    watch: {
      tab (val) {
        var app = this
        setTimeout(function () {
          if (val === 2) {
            app.$refs.weeklyRef.mountedFunction()
          }
        }, 100)
      },
    },
    beforeMount () {
    },
    async mounted () {
      this.checkSyncData()
    },
    methods: {
      async checkSyncData () {
        var app = this
        var connection = this.DB
        var userId = this.$store.state.userId
        var bankCash = {
          name: 'bankCash',
          columns: {
            id: { dataType: 'number' },
            number: { dataType: 'string' },
            name: { dataType: 'string' },
            type: { dataType: 'string' },
          },
        }
        var invoice = {
          name: 'invoice',
          columns: {
            id: { dataType: 'number' },
            accountId: { dataType: 'number' },
            date: { dataType: 'string' },
            type: { dataType: 'string' },
            ouid: { dataType: 'string' },
            store: { dataType: 'boolean' },
          },
        }
        var products = {
          name: 'products',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
            barcode: { dataType: 'string' },
            code: { dataType: 'number' },
            countStock: { dataType: 'number' },
            group_id: { dataType: 'number' },
          },
        }
        var person = {
          name: 'person',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
            amount: { dataType: 'number' },
            mobile: { dataType: 'string' },
            phone: { dataType: 'string' },
            address: { dataType: 'string' },
          },
        }
        var entrepot = {
          name: 'entrepot',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var branch = {
          name: 'branch',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var currency = {
          name: 'currency',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var productGroup = {
          name: 'productGroup',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
          },
        }
        var db = {
          name: 'db_' + userId,
          tables: [products, person, entrepot, branch, productGroup, currency, invoice, bankCash],
        }
        var isDbCreated = await connection.initDb(db)
        if (isDbCreated) {
          // alert('Db Created & connection is opened')
        } else {
          // alert('Connection is opened')
        }
        connection.openDb('db_' + userId)
        this.syncDataErrorText = this.$t('syncDataHaveError')
        connection.select({
          from: 'products',
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('products&services')
            app.syncDataErrorAlert = true
          }
        })
        connection.select({
          from: 'products',
          limit: 1,
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('products&services')
            app.syncDataErrorAlert = true
          }
        })
        connection.select({
          from: 'person',
          limit: 1,
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('person')
            app.syncDataErrorAlert = true
          }
        })
        connection.select({
          from: 'entrepot',
          limit: 1,
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('entrepot')
            app.syncDataErrorAlert = true
          }
        })
        connection.select({
          from: 'branch',
          limit: 1,
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('branch')
            // app.syncDataErrorAlert = true
          }
        })
        connection.select({
          from: 'productGroup',
          limit: 1,
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('productGroup')
            app.syncDataErrorAlert = true
          }
        })
        connection.select({
          from: 'bankCash',
          limit: 1,
        }).then(function (data) {
          if (!data || (data && data.length === 0)) {
            app.syncDataErrorText = app.syncDataErrorText + ' - ' + app.$t('bank')
            app.syncDataErrorAlert = true
          }
        })
      },
      syncData () {
        this.syncDataDialog = true
        this.getAllProductsOffline()
      },
      getAllProductsOffline (type) {
        this.syncDataType = 'products&services'
        var app = this
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'getAllProductOffline',
            formType: type,
          },
        })
          .then(res => {
            res = res.data
            var connection = app.DB
            connection.openDb('db_' + this.$store.state.userId)
            connection.clear('products')
            connection.insert({ into: 'products', upsert: true, values: res })
            app.getAllPersonOffline()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
          })
      },
      getAllPersonOffline () {
        var app = this
        this.syncDataType = 'persons'
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'getAllPersonOffline',
          },
        })
          .then(res => {
            res = res.data
            var connection = app.DB
            connection.openDb('db_' + this.$store.state.userId)
            connection.clear('person')
            connection.insert({ into: 'person', upsert: true, values: res })
            app.getDataOffline('currency')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
          })
      },
      getDataOffline (type) {
        var app = this
        this.syncDataType = type
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: type,
          },
        })
          .then(res => {
            res = res.data
            var connection = app.DB
            connection.openDb('db_' + this.$store.state.userId)
            connection.clear(type)
            connection.insert({ into: type, values: res.data })
            if (type === 'currency') {
              app.getDataOffline('entrepot')
            }
            if (type === 'entrepot') {
              app.getDataOffline('branch')
            }
            if (type === 'branch') {
              app.getDataOffline('bankCash')
            }
            if (type === 'branch') {
              app.getAllProductGroup()
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
          })
      },
      getAllProductGroup () {
        var app = this
        this.syncDataType = 'productGroup'
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'allProductGroup',
          },
        })
          .then(res => {
            res = res.data
            var connection = app.DB
            connection.openDb('db_' + this.$store.state.userId)
            connection.clear('productGroup')
            connection.insert({ into: 'productGroup', values: res })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.syncDataType = ''
            app.syncDataErrorAlert = false
            app.syncDataDialog = false
          })
      },
    },
  }
</script>

<style scoped>
.black-img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
</style>
